import React, { useEffect, useState } from 'react';
import cleanObject from 'src/utils/cleanObject';
import AdminDivisionService from 'src/services/AdminDivision.service';
import BrandAutocomplete, { createOptionsFromArr } from '.';

function WardAutoComplete({
  onChange,
  value,
  name,
  label,
  noLabel = false,
  multiple = false,
  filter = {},
  disabled = false
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWards = async () => {
    setLoading(true);
    try {
      const validFilter = cleanObject(filter);
      if (Array.isArray(validFilter.parentCircle)) {
        validFilter.parentCircle = validFilter.parentCircle.join(',');
      }
      if (Array.isArray(validFilter.parentZone)) {
        validFilter.parentZone = validFilter.parentZone.join(',');
      }
      const { data } = await AdminDivisionService.get({
        ...validFilter,
        type: 'WARD'
      });
      setOptions(data || []);
      // console.log("Wards fetched successfully",data)
    } catch (error) {
      console.error('Wards fetching failed', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWards();
  }, [Object.values(filter).join('')]);
  return (
    <BrandAutocomplete
      label={label ?? 'Ward'}
      noLabel={noLabel}
      placeholder={loading ? 'Loading wards...' : 'Select ward...'}
      onChange={onChange}
      value={value}
      multiple={multiple}
      name={name ?? 'ward'}
      options={createOptionsFromArr(options, 'name', 'id')}
      disabled={disabled}
    />
  );
}

export default WardAutoComplete;
